/**
 * 微信绑定用例
 */

import { onUnmounted, ref } from 'vue'
import { getCSDClient } from '@/lib/csd-adapter'
import { refreshBindUserInfo } from './useBindAccountState'

export function useBindWechat() {
  const qrcodeUrl = ref('')
  const expired = ref(false)
  const loading = ref(false)
  const polling = ref(false)

  let pollTimer: ReturnType<typeof setInterval> | null = null
  let expireTimer: ReturnType<typeof setTimeout> | null = null

  function getClientOrThrow() {
    const client = getCSDClient()
    if (!client) {
      throw new Error('CSD SDK 未初始化')
    }
    return client
  }

  function stop() {
    polling.value = false

    if (pollTimer) {
      clearInterval(pollTimer)
      pollTimer = null
    }

    if (expireTimer) {
      clearTimeout(expireTimer)
      expireTimer = null
    }
  }

  function reset() {
    stop()
    qrcodeUrl.value = ''
    expired.value = false
    loading.value = false
  }

  async function startBind(onBound?: () => void | Promise<void>) {
    const client = getClientOrThrow()

    stop()
    loading.value = true
    expired.value = false

    try {
      qrcodeUrl.value = await client.getUserService().bindWechat()
      polling.value = true

      pollTimer = setInterval(async () => {
        try {
          const userInfo = await refreshBindUserInfo()
          if (userInfo?.openid) {
            stop()
            await onBound?.()
          }
        } catch (error) {
          console.error('轮询微信绑定状态失败:', error)
        }
      }, 2000)

      expireTimer = setTimeout(() => {
        expired.value = true
        stop()
      }, 5 * 60 * 1000)
    } finally {
      loading.value = false
    }
  }

  async function refresh(onBound?: () => void | Promise<void>) {
    expired.value = false
    await startBind(onBound)
  }

  onUnmounted(() => {
    stop()
  })

  return {
    qrcodeUrl,
    expired,
    loading,
    polling,
    startBind,
    refresh,
    stop,
    reset
  }
}
